import { LDSAvatar, LDSHeading, LDSMessages } from "@resmed/lumina-design-system";
import { getTimeOnly } from "../../utils/DateHelper";
import RepliedWidget from "../RepliedWidget";
import MessageContent from "../MessageContent";
import type { CalloutData } from "../../features/chat/types/UIMessage";

export interface ChatBubbleProps {
  id: string;
  avatarImage?: string;
  avatarLabel?: string;
  userName: string;
  content: string;
  timestamp: string;
  calloutData?: CalloutData[];
  isDeleted?: boolean;
  hasAttachment?: boolean;
}

const ChatBubble = ({
  id,
  avatarImage,
  avatarLabel,
  userName,
  content,
  timestamp,
  calloutData,
  isDeleted,
  hasAttachment,
}: ChatBubbleProps) => {
  return (
    <div className="lds-flex lds-items-start lds-gap-[10px]">
      <LDSAvatar
        size="small"
        shape="circle"
        image={avatarImage}
        label={avatarLabel}
        imageFallback="default"
      />
      <div className="lds-flex lds-flex-col lds-max-w-[75%]">
        {/* Name + timestamp above bubble */}
        <div className="lds-flex lds-items-center lds-gap-2 lds-mb-1">
          <LDSHeading
            size="h5"
            className="lds-typography-xs-medium lds-text-textcolor-weak"
          >
            {userName}
          </LDSHeading>
          <LDSHeading
            size="h5"
            className="lds-typography-xs-medium lds-text-textcolor-weak"
          >
            {getTimeOnly(timestamp)}
          </LDSHeading>
        </div>
        {/* key includes state flags so PrimeReact Messages remounts when deletion/attachment changes */}
        <LDSMessages
          key={`${id}-${String(isDeleted)}-${String(hasAttachment)}`}
          id={id}
          severity="secondary"
          viewIcon={false}
          detail={
            calloutData && calloutData.length > 0 ? (
              <>
                <RepliedWidget calloutData={calloutData} />
                <MessageContent content={content} isDeleted={isDeleted} hasAttachment={hasAttachment} />
              </>
            ) : (
              <MessageContent content={content} isDeleted={isDeleted} hasAttachment={hasAttachment} />
            )
          }
          closable={false}
          sticky={true}
          subtle={true}
          wrapperClassName="!lds-px-2"
        />
      </div>
    </div>
  );
};

export default ChatBubble;
